import { useState } from 'react'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { SurveysDataCollection } from './dataCollection'
import { useSurveyOne } from './one'

export default function SurveysListPage() {
  const [canCreateSurvey, setCanCreateSurvey] = useState(false)
  const { handleCreateSurvey } = useSurveyOne({ canCreateSurvey })

  return (
    <ResponsivePage.Body variant="standard">
      <SurveysDataCollection
        handleCreateSurvey={handleCreateSurvey}
        onCanCreateSurveyChange={setCanCreateSurvey}
      />
    </ResponsivePage.Body>
  )
}
